(ns common.schema.entities.ai-summary-configuration.core
  (:require
   [common.schema.entities.ai-summary-configuration.permissions :as permissions]
   [common.schema.entities.ai-summary-configuration.schema :as schema]))

(def entity-type-definition
  {:entity-type :entity.type/ai-summary-configuration
   :schema schema/schema
   :name {:en "AI summary configuration"}
   :plural {:en "AI summary configurations"}
   :icon :fa-robot
   :display-name-fn (fn [{:keys [entity]}]
                      (:ai-summary-configuration/configuration-name entity))
   :display-name/depends-on
   [:ai-summary-configuration/configuration-name]
   :permissions {:creatable? true
                 :disableable? true}
   :entity/mcp-blacklisted? true
   :read-permissions-check-fn permissions/read-permissions?
   :disable-permissions-check-fn permissions/disable-permissions?})
